import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
//
import { LinkMenuComponent } from './linkmenu/linkmenu.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    LinkMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports:[ LinkMenuComponent ],
  providers: [

  ],
})
export class AdminShareModule { }



// WEBPACK FOOTER //
// ./src/app/admin/adminshare.module.ts